import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Rx';

import * as actions from '../store/actions/index';

@Component({
  selector: 'sd-organisation',
  templateUrl: 'organisation.component.html',
  styleUrls: ['organisation.component.scss']
})
export class OrganisationComponent implements OnInit, OnDestroy {
  sub: Subscription;
  organisationId: string;
  constructor(public route: ActivatedRoute, public store: Store<any>) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe(params =>
      this.updateOrganisation(params.organisationId)
    );
  }

  updateOrganisation(id: string) {
    this.organisationId = id;
    this.store.dispatch(actions.Organisations.SelectByIdAction({ id }));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
